export const WORKSPACE_SETUP_PATH = '/workspace-setup';
export const CROSS_ACCOUNT_QUERY_PARAM = 'sitemateStartAccountId';

/**
 * Returns the target Sitemate Start account ID when the user is in a
 * cross-account workspace setup flow (referral from another product like
 * Dashpivot), else null.
 *
 * Falls back to the persisted store value so that the FusionAuth login
 * round-trip — which strips query params from the URL — does not lose the
 * target account.
 */
export function getCrossAccountTargetAccountId(args: {
  pathname: string;
  search: string;
  storedReferenceSmsAccountId: string | null;
  currentOrgAccountId: string | null | undefined;
}): string | null {
  if (args.pathname !== WORKSPACE_SETUP_PATH) return null;

  const urlAccountId = new URLSearchParams(args.search).get(CROSS_ACCOUNT_QUERY_PARAM);
  const target = urlAccountId || args.storedReferenceSmsAccountId;

  if (!target) return null;

  // If `currentOrgAccountId` is null/undefined (user has no cached org, or a legacy workspace
  // with no linked account), we deliberately *don't* short-circuit to "not cross-account". We
  // can't prove sameness, so we let the flow continue with the target; the workspace-setup
  // page and the backend's membership check are the authoritative guards.
  if (target === args.currentOrgAccountId) return null;

  return target;
}
